
import { IUserEventMap, user } from '@app/model';
import { getProxyDispatcher, isDev, Log, toProxy, watchProperty } from '@fanfanlo';
import { ClientEvent, ICreateClientOpts, LoginRequest, LoginResponse, MatrixClient, SyncState } from 'matrix-js-sdk';
import { IMatrixClientEventMap, matrixClient } from './client';
import { matrixModel } from '../mc/MatrixModel';
export interface IMatrixUserInfo{
    loginResponse:LoginResponse|undefined
}

const userInfo:IMatrixUserInfo = toProxy({
    loginResponse:undefined
})

const userData = toProxy({
    userInfo,
})
const fileLogger = new Log(false, 'im.client.user');
// fileLogger.childrenPaused = true;


(
    ()=>{
        function onUpdate(old:any,now:any){
            // console.log('loginResponse.onUpdate', old, now)
    }

    const dispatcher = getProxyDispatcher(userData.userInfo)
    watchProperty(dispatcher,'loginResponse', onUpdate);
    }

)()
async function onUserChanged() {
    const logger = fileLogger.sub(false,'onUserChanged_fn');
    logger.pause = true;
    const homeserver = matrixModel.matrixConf.homeserver
    logger.log('onUserChanged', homeserver);
    if(!homeserver){
        logout();
        return;
    }
    resetClient();
}
async function logout(){
    const log = fileLogger.sub(false, 'logout_fn');
    log.log('logout');
    await dispatchUserSignout();
    matrixClient.client?.stopClient();
}

async function dispatchUserSignout(){
    const log = fileLogger.sub(false, 'dispatchUserSignout_fn');
    log.log('dispatchUserSignout');
    matrixClient.imDispatcher.dispatch<IMatrixClientEventMap>('onUserSignout')
}
async function dispatchUserSignin(){
    const log = fileLogger.sub(false, 'dispatchUserSignin_fn');
    log.pause = true;
    log.log('dispatchUserSignin');
    matrixClient.imDispatcher.dispatch<IMatrixClientEventMap>('onUserSignin')
}
async function resetClient(){
    const log = fileLogger.sub(false, 'resetClient_fn');
    log.pause = true;
    userInfo.loginResponse = undefined;
    log.log('resetClient start');
    try{
        const clientOpts = getClientOpts();
        log.log('clientOpts=', clientOpts)
        if(!clientOpts){
            return;
        }
        const opts:ICreateClientOpts = {
            baseUrl: clientOpts.homeserverUrl,
            
        }
        let client = await matrixClient.createLoginClient(opts);
        log.log('client created')
        const loginOpts:LoginRequest = {
            type:"m.login.password",
            password:clientOpts.userPw,
            user:clientOpts.userName
        }
        const available = await client.isUsernameAvailable(clientOpts.userName);
        log.log('available=', available)
        if(available){
            const opts = {
                username:clientOpts.userName,
                password:clientOpts.userPw,
            }
            // await registerUser(client, clientOpts.userName, clientOpts.userPw);
            await registerUser2(clientOpts.homeserverUrl, clientOpts.userName, clientOpts.userPw);
            // const registerResponse = await client.registerRequest(opts);
            // log.log('registerResponse=', registerResponse)
        }
        const loginResult = await client.loginRequest(loginOpts)
        log.log('loginresult=', loginResult);
        userInfo.loginResponse = loginResult;
        const userOpts = {
            baseUrl:clientOpts.homeserverUrl,
            accessToken: loginResult.access_token,
            userId: loginResult.user_id,
            deviceId: loginResult.device_id,
        }
        log.log('userOpts=', userOpts);
        client = await matrixClient.createProxyClient(userOpts);

        try{

            await client.startClient({
                // initialSyncLimit: isDev ? 8 : 10,
            });
        }catch(e){
            console.error('startClient error=', e);
            throw e;
        }

       
        // 在开发环境下运行测试
        if (process.env.NODE_ENV === 'development') {
            // 监听同步状态变化
            client.on(ClientEvent.Sync, (state: SyncState, prevState: SyncState | null) => {
                if (state === SyncState.Prepared) {
                    // 给一些时间让房间数据完全加载
                    setTimeout(() => {
                        // RoomSettingsTest.runTest();
                    }, 2000);
                }
            });
        }
        await dispatchUserSignin();
        await checkProfile(client);
        log.log('client reset and profile checked');
    }catch(error){
        console.error('resetClient error=', error);
        throw error;
    }
}

async function checkProfile(client:MatrixClient){
    const logger = fileLogger.sub(false, 'checkProfile_fn');
    logger.pause = true;
    const globalUserInfo = user.data.sessionData?.global_user_info;
    if(!globalUserInfo)return;
    logger.log('globalUserInfo=', globalUserInfo)
    // const name = globalUserInfo.nickname || globalUserInfo.name || globalUserInfo.mobile || globalUserInfo.email;
    const name = user.userName;
    if(!name)return;
    logger.log('name=', name)
    const userId = await client.getUserId();
    if(!userId)return;
    logger.log('userId=', userId)
    const profile = await client.getProfileInfo(userId);
    logger.log('profile=', profile)
    if(profile.displayname == name)return;
    logger.log('profile.displayname=', profile.displayname)
    await client.setProfileInfo('displayname', {
        displayname: name,
    });
    logger.log('profile set')
}


export async function registerUser2(homeserverUrl: string, username: string, password: string) {
    const client: MatrixClient = await matrixClient.createLoginClient({
      baseUrl: homeserverUrl,
    });
  
    try {
      // 第一次尝试注册（不带 auth）—— 预期 401，获取 session
      await client.registerRequest({ username, password });
      throw new Error("Unexpected success — homeserver didn't request UIA flow.");
    } catch (err: any) {
      if (err?.data?.session && Array.isArray(err.data.flows)) {
        const sessionId = err.data.session;
  
        // 只支持 m.login.dummy 的情况
        const hasDummy = err.data.flows.some((f: any) =>
          f.stages.includes("m.login.dummy")
        );
        if (!hasDummy) {
          throw new Error("Server does not support m.login.dummy. Cannot proceed.");
        }
  
        // 第二次请求，带上 auth
        const response = await client.registerRequest({
          username,
          password,
          auth: {
            type: "m.login.dummy",
            session: sessionId,
          },
        });
  
        // 注册成功
        return {
          accessToken: response.access_token,
          userId: response.user_id,
          deviceId: response.device_id,
        };
      } else {
        throw new Error("Unexpected registration error: " + JSON.stringify(err.data || err));
      }
    }
  }
  
function getClientOpts() {
    const logger = fileLogger.sub(false, 'getClientOpts_fn');
    // logger.pause = true;
    let userName = '';
    let userPw = '';
    // const homeserverUrl = user.data.imAppUserData?.homeserverUrl;
    const homeserverUrl = matrixModel.matrixConf.homeserver;
    if(!homeserverUrl){
        logger.error('No homeserver url available');
        return;
    }
    if (user.data.storeData.user_token && user.data.sessionData.prime_user_info && user.data.sessionData.prime_user_info.im_matrix_user_id && user.data.sessionData.prime_user_info.im_matrix_pw) {
        const userInfo = user.data.sessionData.prime_user_info;
        if (!userInfo) {
            logger.error('No user info available');
            return;
        }
        if (!userInfo.im_matrix_user_id) {
            logger.error('No user id');
            return;
        }
        if (!userInfo.im_matrix_pw) {
            logger.error("NO user pw")
            return;
        }
        userName = userInfo.im_matrix_user_id;
        userPw = userInfo.im_matrix_pw
    } else {
        const visit = user.data.sessionData.visit
        if (!visit) {
            logger.log('user.data=', JSON.parse(JSON.stringify(user.data)));
            // logger.error('No visit info available');
            return;
        }
        if (!visit.im_matrix_user_id) {
            logger.error('No user id');
            return;
        }
        if (!visit.im_matrix_pw) {
            logger.error("NO user pw")
            return;
        }
        userName = visit.im_matrix_user_id;
        userPw = visit.im_matrix_pw
    }
    if (!userName) {
        logger.error('No user token or device ID available');
        return;
    }
    return { userName, userPw, homeserverUrl }
}

async function listen() {
    user.addListener<IUserEventMap>('onUserChanged', onUserChanged)
}

async function init(){
    listen();
}
export const matrixUser = {
    init,
    userData,
}